import type { Options } from '@contentful/rich-text-react-renderer';

const createMergedOptions = (options1: Options, options2: Options): Options => {
  const hasRenderMark = options1.renderMark || options2.renderMark;
  const hasRenderNode = options1.renderNode || options2.renderNode;

  return {
    ...options1,
    ...options2,
    ...(hasRenderMark && {
      renderMark: {
        ...options1.renderMark,
        ...options2.renderMark,
      } as Options['renderMark'],
    }),
    ...(hasRenderNode && {
      renderNode: {
        ...options1.renderNode,
        ...options2.renderNode,
      } as Options['renderNode'],
    }),
  };
};

function isFunnel(url: URL): boolean {
  let funnel = false;
  if (url.pathname.includes('/transport/flights/')) {
    // Is flight funnel
    funnel = true;
  } else if (url.pathname.includes('/carhire/results/')) {
    // Is car hire funnel
    funnel = true;
  } else if (url.pathname.includes('/hotels/search')) {
    // Is hotels funnel
    funnel = true;
  }
  return funnel;
}

function isExternal(url: URL): boolean {
  return (
    !url.hostname.includes('skyscanner.') && !url.hostname.includes('tianxun.')
  );
}

function getRel(url: URL): string | null {
  let rel = null;
  if (isExternal(url)) {
    rel = 'noopener noreferrer nofollow';
  } else if (isFunnel(url)) {
    rel = 'nofollow';
  }
  return rel;
}

/**
 * Resolves a URL to a full URL
 * @param {string} url The URL to resolve
 * @param {string} currentHref The current URL
 * @returns {URL} The resolved URL
 */
const resolveFullUrl = (url: string): URL => {
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return new URL(url);
  }

  if (url.startsWith('www.')) {
    return new URL(`https://${url}`);
  }

  if (url.startsWith('skyscanner.') || url.startsWith('tianxun.')) {
    return new URL(`https://www.${url}`);
  }

  throw new Error(`Invalid URL: ${url}`);
};

export { createMergedOptions, getRel, isExternal, resolveFullUrl };
